import Utils from "../utils/Utils";
import ApiService from "./ApiService";
import WeeklyTimesheetAudit from "../models/WeeklyTimesheetAudit";

export default class WeeklyTimesheetAuditService {
  public static async get(id: string): Promise<WeeklyTimesheetAudit | null> {
    return new Promise((resolve, reject) => {
      ApiService.get(`/weeklyTimesheetAudit/${id}`, "")
        .then((Result) => {
          if (!Result.data) {
            resolve(null);
          } else {
            const retVal = { id: Result.data.id, ...Result.data } as WeeklyTimesheetAudit;
            retVal.WeekStartDate = Utils.vsDateToDatetime(Result.data.WeekStartDate);
            retVal.ApprovedOn = Utils.vsDateToDatetime(Result.data.ApprovedOn);
            resolve(retVal);
          }
        })
        .catch((weeklyTimesheetAuditError) => reject(weeklyTimesheetAuditError));
    });
  }

  public static async getList(startDate: Date, endDate: Date): Promise<WeeklyTimesheetAudit[]> {
    return new Promise((resolve, reject) => {
      const fromDate = Utils.addTimezoneOffsetToStartDate(startDate);
      const toDate = Utils.addTimezoneOffsetToStartDate(endDate);
      ApiService.post(`/weeklyTimesheetAudit/getListByDateRange`, { startDate: fromDate, endDate: toDate })
        .then((Result) => {
          if (!Result.data) {
            resolve([]);
          } else {
            const retVal = Result.data.map((doc: any) => {
              const item = { id: doc.id, ...doc } as WeeklyTimesheetAudit;
              item.WeekStartDate = Utils.vsDateToDatetime(doc.WeekStartDate);
              item.ApprovedOn = Utils.vsDateToDatetime(doc.ApprovedOn);
              return item;
            });
            resolve(retVal);
          }
        })
        .catch((weeklyTimesheetAuditError) => reject(weeklyTimesheetAuditError));
    });
  }

  public static async revoke(id: string): Promise<string> {
    return new Promise((resolve, reject) => {
      ApiService.post(`/weeklyTimesheetAudit/${id}`, "")
        .then((result) => {
          resolve(result.data);
        })
        .catch((error) => reject(error));
    });
  }

  public static async create(model: WeeklyTimesheetAudit): Promise<WeeklyTimesheetAudit | null> {
    model.WeekStartDate = Utils.addTimezoneOffset(model.WeekStartDate);
    return new Promise((resolve, reject) => {
      ApiService.post("/weeklyTimesheetAudit", model)
        .then((result) => {
          if (result.data) {
            model.id = result.data;
            resolve(model);
          } else {
            resolve({} as WeeklyTimesheetAudit);
          }
        })
        .catch((error) => reject(error));
    });
  }
}
